import React from 'react';
import { Box, Card, CardHeader, CardContent, Stack, Tabs, Tab } from '@mui/material';

import Scrollbar from '../../../../../components/Scrollbar';
import DietForm from './DietForm';
import { useSelector } from 'react-redux';
import PLDietForm from './PLDietForm';
import PeriodDietForm from './PeriodDietForm';

export const FullScreenView = props => {
  const { data, submitCallback, handleClose, allSeasons, allCamps, allEvents, allPeriods } = props;
  const { module } = useSelector(state => state.app);

  return (
    <Scrollbar>
      <Box display="flex" flexDirection="row" justifyContent="space-between" mt={1} mr={2}>
        <Stack flex="1 1 70%">
          <Card>
            <CardHeader title={data ? 'Edytuj diete' : 'Dodaj diete'} sx={{ mt: -1, mb: -2 }} />
            <CardContent>
              { module == 'polkolonie'
                ? <PLDietForm data={data} submitCallback={submitCallback} handleClose={handleClose} allSeasons={allSeasons} allEvents={allEvents} />
                : ['wyjazdy_rodzinne', 'zielone_szkoly'].includes(module) ? <PeriodDietForm data={data} submitCallback={submitCallback} handleClose={handleClose} allSeasons={allSeasons} allCamps={allCamps} allPeriods={allPeriods} />
                  : <DietForm data={data} submitCallback={submitCallback} handleClose={handleClose} allSeasons={allSeasons} allCamps={allCamps} />
              }
            </CardContent>
          </Card>
        </Stack>
      </Box>
    </Scrollbar>
  );
};
